import Clusterer from './Clusterer'
import DeviceMarker from './DeviceMarker'
import FilterControl from './FilterControl'
import LayerControl from './LayerControl'
import GoogleMapContainer from './MapContainer'
import ParkingLotMarker from './ParkingLogMarker'
import PlaceSearchControl from './PlaceSearchControl'
import { GoogleMapProvider, useGoogleMap } from './Provider'
import SessionMarker from './SessionMarker'

type IGoogleMapContainer = typeof GoogleMapContainer

interface IInternalGoogleMap extends IGoogleMapContainer {
  //   Provide: typeof Provider
  //   LayerToogle: typeof LayerToogle
  //   ZoomControl: typeof ZoomControlFC
  //   Marker: typeof Marker
  //   Tooltip: typeof Tooltip
  //   Popup: typeof Popup
  //   MarkerCluster: typeof MarkerCluster
  DeviceMarker: typeof DeviceMarker
  SessionMarker: typeof SessionMarker
  Clusterer: typeof Clusterer
  Provider: typeof GoogleMapProvider
  useGoogleMap: typeof useGoogleMap
  FilterControl: typeof FilterControl
  LayerControl: typeof LayerControl
  PlaceSearchControl: typeof PlaceSearchControl
  ParkingLotMarker: typeof ParkingLotMarker
}

const GoogleMap: IInternalGoogleMap = GoogleMapContainer as IInternalGoogleMap
// MapLibre.Provide = Provider
// MapLibre.LayerToogle = LayerToogle
// MapLibre.ZoomControl = ZoomControlFC
// MapLibre.Marker = Marker
// MapLibre.Tooltip = Tooltip
// MapLibre.Popup = Popup
// MapLibre.MarkerCluster = MarkerCluster
GoogleMap.DeviceMarker = DeviceMarker
GoogleMap.SessionMarker = SessionMarker
GoogleMap.Clusterer = Clusterer
GoogleMap.Provider = GoogleMapProvider
GoogleMap.useGoogleMap = useGoogleMap
GoogleMap.FilterControl = FilterControl
GoogleMap.LayerControl = LayerControl
GoogleMap.PlaceSearchControl = PlaceSearchControl
GoogleMap.ParkingLotMarker = ParkingLotMarker

export default GoogleMap
